import { render, staticRenderFns } from "./miniappconfig.vue?vue&type=template&id=2f44bc92&"
import script from "./miniappconfig.vue?vue&type=script&lang=ts&"
export * from "./miniappconfig.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "miniappconfig.vue"
export default component.exports